import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: Number,
    downloadText: String
  }

  connect() {
    console.log("[label-modal] Connected")
    this.timer = setInterval(() => this.check(), this.intervalValue || 3000)
    this.check()
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async check() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      const data = await response.json()

      const { package_created, label_ready, label_failed, label_url } = data
      const downloadArea = document.getElementById("label-download")

      // Step 3: label ready → success, end polling
      if (label_ready) {
        this.markStepDone("package")
        this.markStepDone("label")
        this.markStepDone("download")
        clearInterval(this.timer)

        downloadArea.innerHTML = `
        <a href="${label_url}" class="btn btn-success" target="_blank">
          <i class="bi bi-filetype-pdf"></i>
          <span class="ms-2">${this.downloadTextValue}</span>
        </a>`
        return
      }

      // Step: label_failed → error, stop polling
      if (label_failed) {
        clearInterval(this.timer)
        downloadArea.innerHTML = `
        <div class="alert alert-danger mt-3">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Failed to generate label.
        </div>`
        return
      }

      // Step 1: the package has not been created yet
      if (!package_created) {
        this.setActiveStep("package")
        return
      }

      // Step 2: paczka ok, ale etykieta jeszcze się tworzy
      this.markStepDone("package")
      this.setActiveStep("label")

    } catch (e) {
      console.error("Label check failed", e)
    }
  }

  setActiveStep(step) {
    const li = document.querySelector(`#label-steps [data-step="${step}"]`)
    const iconWrapper = li?.querySelector("[data-icon]")
    if (!iconWrapper) return

    this.fadeIcon(iconWrapper, `
      <span class="spinner-border spinner-border-sm text-secondary me-2" role="status" style="width: 1rem; height: 1rem;"></span>
    `)
  }

  markStepDone(step) {
    const li = document.querySelector(`#label-steps [data-step="${step}"]`)
    const iconWrapper = li?.querySelector("[data-icon]")
    if (!iconWrapper) return

    this.fadeIcon(iconWrapper, `<i class="bi bi-check-circle-fill text-success me-2"></i>`)
  }

  fadeIcon(wrapper, newHTML) {

    wrapper.style.opacity = 1
    wrapper.style.transform = 'scale(1)'
    wrapper.style.transition = 'opacity 0.2s ease, transform 0.2s ease'
    wrapper.style.opacity = 0
    wrapper.style.transform = 'scale(0.8)'

    setTimeout(() => {
      wrapper.innerHTML = newHTML

      wrapper.style.opacity = 0
      wrapper.style.transform = 'scale(1.2)'
      wrapper.style.transition = 'none'

      requestAnimationFrame(() => {
        wrapper.style.transition = 'opacity 0.3s ease, transform 0.3s ease'
        wrapper.style.opacity = 1
        wrapper.style.transform = 'scale(1)'
      })
    }, 200)
  }
}